import { render, staticRenderFns } from "./ViqExpertCommentary.vue?vue&type=template&id=0d0c3e96&scoped=true"
import script from "./ViqExpertCommentary.vue?vue&type=script&lang=js"
export * from "./ViqExpertCommentary.vue?vue&type=script&lang=js"
import style0 from "./ViqExpertCommentary.vue?vue&type=style&index=0&id=0d0c3e96&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c3e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0c3e96')) {
      api.createRecord('0d0c3e96', component.options)
    } else {
      api.reload('0d0c3e96', component.options)
    }
    module.hot.accept("./ViqExpertCommentary.vue?vue&type=template&id=0d0c3e96&scoped=true", function () {
      api.rerender('0d0c3e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqExpertCommentary.vue"
export default component.exports